module.exports = __webpack_public_path__ + "img/tree-2.9cf02980.png";